import request from '@/utils/request'

// 查询CMS文章分页
export function pageArticle(query) {
  return request({
    url: '/article/page',
    method: 'get',
    params: query
  })
}

// 新增CMS文章
export function addArticle(data) {
  return request({
    url: '/article/add',
    method: 'post',
    data: data
  })
}

// 编辑CMS文章
export function editArticle(data) {
  return request({
    url: '/article/edit',
    method: 'post',
    data: data
  })
}

// 查询CMS文章详情
export function getArticle(id) {
  return request({
    url: '/article/detail?id=' + id,
    method: 'get'
  })
}

// 删除CMS文章
export function delArticle(data) {
  return request({
    url: '/article/delete',
    method: 'post',
    data: data
  })
}

// 发布CMS文章
export function releaseArticle(data) {
  return request({
    url: '/article/release',
    method: 'post',
    data: data
  })
}

// 下架CMS文章
export function unreleaseArticle(data) {
  return request({
    url: '/article/unre/lease',
    method: 'post',
    data: data
  })
}
